import { uniqBy } from 'lodash';
import WaterLevelColor from '../../../components/color/waterlevel/WaterLevelColor';

export default function WaterLevelData(currentMode, currentArea, datas, dataTime) {
  let name;
  const mode = currentMode;
  const area = currentArea;
  let wlData = [];
  if (mode === 'province' && area.code !== '0') {
    wlData = datas.filter((d) => d.geocode.province_code === area.code);
  } else if (mode === 'basin' && area.code !== '0') {
    wlData = datas.filter((d) => d.basin.basin_code === parseInt(area.code, 10));
  } else {
    wlData = datas;
  }

  const wlFilterData = wlData.filter((d) => d.storage_percent !== null)
    .map((row) => {
      const status = WaterLevelColor(row.storage_percent);
      if (area.code === '0') {
        name = row.geocode.province_name.th;
      } else {
        name = row.geocode.amphoe_name.th;
      }
      return {
        level: status.level,
        name,
        id: row.id,
        tele_station_lat: row.station.tele_station_lat,
        tele_station_long: row.station.tele_station_long,
        tele_station_oldcode: row.station.tele_station_oldcode,
        agency_name: row.agency.agency_name.th,
        basin_name: row.basin.basin_name.th,
        waterlevel_datetime: row.waterlevel_datetime,
        tele_station_name: row.station.tele_station_name.th,
        storage_percent: row.storage_percent,
        tumbon_name: row.geocode.tumbon_name.th,
        amphoe_name: row.geocode.amphoe_name.th,
        province_name: row.geocode.province_name.th,
        ground_level: row.station.ground_level,
        min_bank: row.station.min_bank,
        waterlevel_msl: row.waterlevel_msl,
      };
    });

  // น้ำน้อยวิกฤต
  const varWlYellow = uniqBy(wlFilterData.filter((d) => d.level === 1), 'name')
    .sort((a, b) => a.name.localeCompare(b.name, 'th'));

  // น้ำล้นตลิ่ง
  const varWlRed = uniqBy(wlFilterData.filter((d) => d.level === 5), 'name')
    .sort((a, b) => a.name.localeCompare(b.name, 'th'));

  // นับจำนวนสถานีน้ำล้นตลิ่ง
  const wlRedCount = varWlRed.length;

  const wlList = {
    time: dataTime,
    count: wlRedCount,
    yellow: varWlYellow,
    red: varWlRed,
  };

  // แผนที่ plot เฉพาะ ตำแหน่งสถานี น้ำล้นตลิ่ง หรือ น้ำน้อยวิกฤต
  const wlFilterLevel = wlFilterData.filter((d) => d.level === 1 || d.level === 5);

  return ({
    wlRedCount,
    wlList,
    wlFilterLevel,
  });
}
